import ReportLinkHelper from '../../helpers/reportLinkHelper.jsx';
import {emailSendingTypes, countries} from '../../helpers/constants.jsx';
import {getContactName} from '../../helpers/dataHelpers';

// Register in router

// Api

// Libs
import isInternetExplorer from '../../helpers/internetExplorer.jsx';
import ReportViewer from '../../components/reports/reportViewer.jsx';
import EmailModal from '../../components/layout/emailModal.jsx';
import PageFooter from '../../components/layout/pageFooter.jsx';
import Header from '../../components/layout/header.jsx';
import FooterButton from '../../components/layout/footerButton.jsx';
import events from '../../../lib/events.js';
import router from '../../../lib/router.js';
import customerApi from '../../../api/customer.jsx';
import dealerApi from '../../../api/dealer';
import routeUtils from '../../../util/routeUtils.jsx';
import ReactDOM from 'react-dom';
import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import IntlWrapper from 'components/layout/intlWrapper';
import Dealer from 'models/dealer';
import session from 'services/sessionService';

let render = (container, params) => {
  console.info('[UI.page.customer] rendering page season usage');
  ReactDOM.render(<IntlWrapper><SeasonUsageWrapper customerID={parseInt(params.id)}
                                                   systemID={parseInt(params.system)}/></IntlWrapper>, container);
  events.publish('page-change', {page: 'customer'});
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'customer/:id/:system/season-usage', handler: routeUtils.requireAuth(render)}]);

class SeasonUsage extends React.Component {
  static propTypes = {
    customerID: PropTypes.number.isRequired,
    systemID: PropTypes.number.isRequired,
    intl: intlShape.isRequired,
  };

  state = {
    customer: {
      customerContacts: [],
    },
    dealer: new Dealer({}),
    reportURL: '',
  };

  componentDidMount() {
    this.updateLink(this.props);
    let apis = [];

    apis.push(dealerApi.getDealer(session.getUser().dealerId));
    apis.push(customerApi.getCustomer(this.props.customerID));
    Promise.all(apis)
    .then(([dealer, customer]) => {
      this.setState({
        dealer: dealer,
        customer: customer,
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    this.updateLink(nextProps);
  }

  updateLink = (props = this.props) => {
    ReportLinkHelper.getSeasonUsageLink(props.systemID, props.intl.locale)
      .then((xhr, response) => {
        this.setState({
          reportURL: response,
          reportURLInternal: '/ReportViewer?' + response.split('?')[1],
        });
      });
  };

  print = () => {
    let win = window.open(this.state.reportURLInternal);

    win.print();
  };

  render() {
    let contact = null;
    let contactName = 'Customer';

    if (this.state.customer.customerContacts.length > 0) {
      contact = this.state.customer.customerContacts[0];
      contactName = getContactName(contact, contactName);
    }

    let emailModal =
      <EmailModal
        title={this.props.intl.formatMessage({id: 'quick-calcs.seasons-usage.title'})}
        subject={this.props.intl.formatMessage({id: 'quick-calcs.seasons-usage.title'})}
        customerID={this.props.customerID}
        contacts={this.state.customer.customerContacts}
        type={emailSendingTypes.seasonsUsage}
        poolID={this.props.systemID}
        reportURL={this.state.reportURL}
        caslRestricted={this.state.dealer.country === countries.CA}/>;

    let ieHeader = isInternetExplorer() ?
      <div className='ie-header'>
        {emailModal}
        <FooterButton label='Print'
                      icon='bl bl-2x bl-print'
                      onClick={this.print}/>
        <div className='clearfix'/>
      </div> :
      null;

    return <div className='customer-system-season-usage container'>
      <Header mainTitle={contactName}
              mainTitleReturn={'customer/' + this.props.customerID}
              subTitle={<FormattedMessage id='quick-calcs.seasons-usage.title' />}/>
      {ieHeader}

      <ReportViewer url={this.state.reportURLInternal}/>

      {
        !isInternetExplorer() &&
        <PageFooter>
          {emailModal}
        </PageFooter>
      }
    </div>;
  }
}

let SeasonUsageWrapper = injectIntl(SeasonUsage);

export default SeasonUsage;
